import { LogOut } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Person from "@/assets/icons/person.svg?react";
import VoiceekLogo from "@/assets/Voiceek_logo.svg?react";
import Button from "@/components/ui/Button";
import WorkspaceSwitch from "@/components/ui/WorkspaceSwitch";
import useAuth from "@/hooks/useAuth";
import { useAppStore } from "@/stores/ui/useAppStore";

export const Header: React.FC = () => {
  const { t } = useTranslation("common");
  const { authUser, logout } = useAuth();
  const setIsAgentMode = useAppStore(s => s.setIsAgentMode);

  return (
    <div className="bg-white h-[60px] w-full flex justify-between items-center px-[20px]">
      <Link to="/" onClick={() => setIsAgentMode(false)}>
        <VoiceekLogo />
      </Link>

      <div className="flex items-center gap-5">
        <WorkspaceSwitch />

        <div className="flex justify-between items-center h-6 gap-[5px]">
          <Person />

          {authUser && (
            <div className="">
              {authUser.name}
            </div>
          )}
        </div>

        <Button variant="outline" className="h-[34px]" onClick={logout}>
          <LogOut className="h-6 w-6" />
          <span>{t("auth.logout")}</span>
        </Button>
      </div>
    </div>
  );
};
